// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';


// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

import $ from 'jquery';

( function() {    

    new Swiper(".swiper--reference-slider", {
        modules: [ Navigation, Autoplay ],
        slidesPerView: 2,
        slidesPerGroup: 2,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        loop: true
    });


} )()